module.exports = __webpack_public_path__ + "static/media/search-plus.fc63b909.svg";